import { useRef } from "react";
import "./storefront.css";

interface HomeProps {
  onStart: () => void;
  onLogin: () => void;
  loggedIn: boolean;
}

const assets = "/assets/bewild/";

function ServiceIcon({ kind }: { kind: "delivery" | "orders" | "support" }) {
  return (
    <svg viewBox="0 0 80 80" fill="none" aria-hidden="true">
      {kind === "delivery" && (
        <>
          <path d="m40 10 24 13v30L40 67 16 53V23l24-13Z" />
          <path d="m16 23 24 14 24-14M40 37v30M28 17l24 14v13" />
        </>
      )}
      {kind === "orders" && (
        <>
          <path d="M49 67H21a6 6 0 0 1-6-6V16a6 6 0 0 1 6-6h26l14 14v14M46 10v16h15M26 37h17M26 48h12" />
          <circle cx="57" cy="55" r="17" />
          <path d="M57 45v11l7 4" />
        </>
      )}
      {kind === "support" && (
        <>
          <path d="M15 42v-6a25 25 0 0 1 50 0v19a13 13 0 0 1-13 13h-9" />
          <rect x="10" y="35" width="13" height="23" rx="6" />
          <rect x="57" y="35" width="13" height="23" rx="6" />
          <path d="M36 68h7" />
        </>
      )}
    </svg>
  );
}

export default function Home({ onStart, onLogin, loggedIn }: HomeProps) {
  const hero = useRef<HTMLElement>(null);

  return (
    <div className="bw-home">
      <header className="bw-home-header">
        <a className="bw-home-logo" href="/" aria-label="PandAI 首页">
          <img src="/pandai-wordmark.png" alt="PandAI" width={1942} height={809} />
        </a>
        <nav aria-label="首页导航">
          <button className="bw-home-nav-link" onClick={onStart}>
            订阅服务
          </button>
          <button className="bw-home-login" onClick={onLogin}>
            {loggedIn ? "个人中心" : "登录 / 注册"}
            <span aria-hidden="true">↗</span>
          </button>
        </nav>
      </header>

      <main>
        <section
          ref={hero}
          className="bw-home-hero"
          aria-labelledby="bw-home-title"
          onPointerMove={(event) => {
            if (event.pointerType !== "mouse") return;
            const bounds = event.currentTarget.getBoundingClientRect();
            hero.current?.style.setProperty(
              "--hero-x",
              `${event.clientX - bounds.left}px`,
            );
            hero.current?.style.setProperty(
              "--hero-y",
              `${event.clientY - bounds.top}px`,
            );
          }}
        >
          <div className="bw-home-flow" aria-hidden="true">
            <img src={`${assets}landing-hero-flow-mark-kGj7QkD2.svg`} alt="" />
          </div>
          <div className="bw-home-glow" aria-hidden="true" />
          <img
            className="bw-home-mobile-mark"
            src={`${assets}landing-hero-mark-CJOAMfHY.svg`}
            alt=""
            aria-hidden="true"
          />
          <div className="bw-home-hero-content">
            <h1 id="bw-home-title">轻松订阅</h1>
            <p className="bw-home-products">
              <span>GPT / Claude</span>
              <span className="bw-home-product-divider"> / </span>
              <span>Gemini</span>
            </p>
            <img
              className="bw-home-product-icons"
              src={`${assets}landing-hero-icons-CTvaWOEy.svg`}
              alt=""
              aria-hidden="true"
            />
            <button className="bw-home-start" onClick={onStart}>
              立即订阅
            </button>
          </div>
        </section>

        <section className="bw-home-services" aria-label="服务说明">
          <div className="bw-home-services-inner">
            <article>
              <ServiceIcon kind="delivery" />
              <h2>按商品说明交付</h2>
              <p>
                选择适合的服务与套餐，
                <br />
                购买前查看交付方式和使用说明。
              </p>
            </article>
            <article>
              <ServiceIcon kind="orders" />
              <h2>订单进度可查</h2>
              <p>
                凭查询邮箱和查询密码，
                <br />
                在我的订单中查看支付状态与交付内容。
              </p>
            </article>
            <article>
              <ServiceIcon kind="support" />
              <h2>在线客服</h2>
              <p>
                需要帮助时打开在线客服，
                <br />
                带上订单号直接对话。
              </p>
            </article>
          </div>
        </section>
      </main>

      <footer className="bw-home-footer">
        <div className="bw-home-footer-inner">
          <a href="/" aria-label="PandAI 首页">
            <img src="/pandai-wordmark.png" alt="PandAI" width={1942} height={809} />
          </a>
          <p>pandai.shop</p>
          <div className="bw-home-footer-bottom">
            <span>© {new Date().getFullYear()} PandAI</span>
            <button onClick={onStart}>
              订阅服务 <span aria-hidden="true">↗</span>
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
}
